module.exports = __webpack_public_path__ + "static/media/hamburger.4e4e2d2f.svg";